module.exports = __webpack_public_path__ + "static/media/kalilinux.a779093c.png";